
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#CCC","d":"M7 0C3.1 0 0 3.1 0 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm.5 10.9c0 .1-.1.2-.2.3-.1.1-.2.1-.3.2s-.2.1-.3.1c-.1 0-.2 0-.3-.1s-.2-.1-.2-.2c-.1-.1-.2-.2-.2-.3 0-.1-.1-.2-.1-.4 0-.1 0-.2.1-.4 0-.1.1-.2.2-.3l.2-.2c.1-.1.2-.1.3-.1.1 0 .2 0 .3.1s.2.1.3.2c.1.1.1.2.2.3s.1.2.1.4 0 .3-.1.4zm1.7-5.5c-.1.2-.2.4-.4.6s-.2.3-.4.4-.3.2-.5.3l-.3.3c-.1.1-.2.1-.2.3l-.1.7h-1l-.1-.8c0-.2 0-.3.1-.4s.2-.2.3-.4c.1-.2.2-.3.4-.4.2-.1.3-.2.4-.4s.2-.3.3-.4c.1-.2.1-.4.1-.6 0-.1 0-.3-.1-.4.1 0 0-.1-.1-.2s-.2-.2-.3-.2-.3-.1-.5-.1-.4 0-.6.1-.2.1-.3.2c-.1 0-.2.1-.3.1s-.2.1-.2.1c-.2 0-.3 0-.3-.2l-.4-.6c.1-.1.3-.2.4-.3.2-.1.4-.2.5-.3.2-.1.4-.1.7-.2s.4 0 .7 0c.4 0 .7 0 1 .1.3.1.5.2.7.4.2.2.3.4.5.7s.2.5.2.8-.1.6-.2.8z"}})])
          )
        }
      }
    